import { useRef, useState } from 'react';
import AppBar from '../components/appBar';
import Page from '../components/page';
import main, { AppLocalKey } from '../main';
import { validateTel } from '../utils/utils';
import { LoadingMask, showConfirm, showToast } from '../components/dialog';
import { apiGetSmsCode, apiLogin } from '../api';
import Radiobox from '../components/radioBox';
import Button from '../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userInfoRequest } from '../redux/userInfoReducer';
import { ProtocolType } from './protocolPage';

export default function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [time, setTime] = useState(0);
  const timerRef = useRef<{ timer?: NodeJS.Timeout; time: number }>({ time: 0 });
  const [checkProtocol, setCheckProtocol] = useState(false);
  async function handleSendCaptcha() {
    if (timerRef.current.time > 0) {
      return;
    }
    if (!validateTel(username)) {
      return showToast('请输入正确的手机号');
    }
    LoadingMask.show('正在发送...');
    try {
      var res = await apiGetSmsCode(username);
      var data = res.data;
      if (data.code === 200) {
        showToast('验证码发送成功');
        startTimer();
      } else {
        showToast(data.msg ?? '发送失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '发送失败');
    } finally {
      LoadingMask.hide();
    }
  }

  function startTimer() {
    if (timerRef.current.timer) {
      clearInterval(timerRef.current.timer);
    }
    timerRef.current.time = 60;
    setTime(timerRef.current.time);
    timerRef.current.timer = setInterval(() => {
      if (timerRef.current.time === 0) {
        clearInterval(timerRef.current.timer);
        timerRef.current.timer = undefined;
      }
      setTime(timerRef.current.time--);
    }, 1000);
  }

  async function handleLogin() {
    if (!validateTel(username)) {
      return showToast('请输入正确的手机号');
    }
    if (!captcha) {
      return showToast('请输入验证码');
    }
    if (!checkProtocol) {
      let res = await showConfirm({
        title: '提示',
        content: '请阅读并同意《用户协议》和《隐私政策》',
        confirmBtnText: '同意协议',
      });
      if (res !== 1) return;
    }
    LoadingMask.show('正在登录...');
    try {
      var res = await apiLogin(username, captcha, location.state?.invitationCode);
      var data = res.data;
      if (data.code === 200) {
        showToast(data.msg ?? '登录成功');
        var token = data.data.access_token;
        localStorage.setItem(AppLocalKey.loginToken, token);
        main.loginToken = token;
        dispatch(userInfoRequest());
        if (location.state?.invitationCode) {
          navigate('/download', { replace: true });
        } else {
          navigate(-1);
        }
      } else {
        showToast(data.msg ?? '登录失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '登录失败');
    } finally {
      LoadingMask.hide();
    }
  }

  return (
    <div className="pos-r">
      <img className="pos-a z-0 bw-100" src={main.pic('pic_login_bg.png')} alt="" />
      <Page className="pos-r z-10" contentClassName="pt-250" appBar={<AppBar title="" className="bg-color-t0" />}>
        <div className="mh-20 pv-10 border-bottom d-flex-r">
          <input
            className="flex-1"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="请输入手机号"
            type="text"
            maxLength={11}
          />
          <img className="w-16 h-16" src={main.pic('icon_login_user.png')} alt="" />
        </div>
        <div className="mh-20 pv-10 border-bottom d-flex-r mt-10">
          <input
            className="flex-1"
            value={captcha}
            onChange={(e) => setCaptcha(e.target.value)}
            placeholder="请输入验证码"
            type="text"
            maxLength={6}
          />
          <div className={time > 0 ? 'text-color-9' : 'text-color-primary'} onClick={handleSendCaptcha}>
            {time > 0 ? `${time}(s)` : '获取验证码'}
          </div>
        </div>
        <div className="d-flex-r ai-start p-20">
          <Radiobox className="mr-5" value={checkProtocol} onChange={(v) => setCheckProtocol(!checkProtocol)} />
          <span onClick={(v) => setCheckProtocol(!checkProtocol)}>已阅读并同意</span>
          <span className="text-color-primary" onClick={() => navigate('/protocol?type=' + ProtocolType.user)}>
            《用户协议》
          </span>
          <span>和</span>
          <span className="text-color-primary" onClick={() => navigate('/protocol?type=' + ProtocolType.privacy)}>
            《隐私政策》
          </span>
        </div>
        <div className="ph-20">
          <Button type="primary" size="md" shape="circle" long onClick={handleLogin}>
            登录/注册
          </Button>
        </div>
      </Page>
    </div>
  );
}
